import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
/* eslint-disable max-lines, max-lines-per-function */
import { useCallback, useEffect } from '@redneckz/uni-jsx/lib/hooks';
import { useForm } from '../../hooks/useForm.js';
import { Button } from '../../ui-kit/Button/Button.js';
import { CalculatorLayout } from '../../ui-kit/Calculator/CalculatorLayout.js';
import { CalculatorStyle } from '../../ui-kit/Calculator/CalculatorStyle.js';
import { getDefaultParamsMax } from '../../ui-kit/Calculator/getDefaultParams.js';
import { getMoneyDefaultValue, getMonthsDefaultValue, } from '../../ui-kit/Calculator/getDefaultValues.js';
import { renderMonthsInput } from '../../ui-kit/Calculator/renderMonthsInput.js';
import { renderRate } from '../../ui-kit/Calculator/renderRate.js';
import { renderWantedSumInput } from '../../ui-kit/Calculator/renderWantedSumInput.js';
import { setDefaultParamsCalc } from '../../ui-kit/Calculator/setDefaultParamsCalc.js';
import { SelectControl } from '../../ui-kit/Select/SelectControl.js';
import { UniBlock } from '../../UniBlock/UniBlock.js';
import { style } from '../../utils/style.js';
import { isDefaultParams } from '../CalculatorCredit/isDefaultParams.js';
import { getDepositCalculatorParams, } from './getDepositCalculatorParams.js';
import { isRubles } from './isRubles.js';
import { renderDepositParamsForm } from './renderDepositParamsForm.js';
import { renderDepositResult } from './renderDepositResult.js';
import { getRows, normalizeCurrency, normalizeMoneyValue, normalizeMonthValue, normalizeReplenishWithdrawn, } from './utils.js';
const MAP = {
    isMonthlyInterestPayment: 'isMonthlyInterestPayment',
    isRemoteRegistration: 'isRemoteRegistration',
    isReplenish: 'isReplenish',
    isWithdrawn: 'isWithdrawn',
    moneyValue: 'minSum',
};
const DEFAULT_CURRENCY = {
    text: '₽',
    key: 'rub',
};
const DEPOSIT_DEFAULT_SUM = 20000;
const DEPOSIT_DEFAULT_MONTHS = 1;
export const CalculatorDeposit = UniBlock(({ className, title, calcSource, buttons = [], footnote = '', paramsViewSettings, defaultParams, ...rest }) => {
    const { rows } = calcSource ?? {};
    const currencyOptions = rows?.map((_) => _.currency) ?? [DEFAULT_CURRENCY];
    const normalize = useCallback((_) => !rows
        ? _
        : {
            ..._,
            ...normalizeReplenishWithdrawn(_),
            ...normalizeMoneyValue(_, rows),
            ...normalizeMonthValue(_, rows),
            ...normalizeCurrency(_, rows),
        }, [rows]);
    const [userInputParams, { field }] = useForm({
        moneyValue: getMoneyDefaultValue(defaultParams, DEPOSIT_DEFAULT_SUM),
        monthsValue: getMonthsDefaultValue(defaultParams, DEPOSIT_DEFAULT_MONTHS),
        isMonthlyInterestPayment: Boolean(defaultParams?.isMonthlyInterestPayment),
        isRemoteRegistration: Boolean(defaultParams?.isRemoteRegistration),
        isReplenish: Boolean(defaultParams?.isReplenish),
        isWithdrawn: Boolean(defaultParams?.isWithdrawn),
        isNewClient: Boolean(defaultParams?.isNewClient),
        currency: DEFAULT_CURRENCY,
    }, { normalize });
    const currencyValue = field?.('currency')?.value ?? DEFAULT_CURRENCY;
    const isNewClient = field?.('isNewClient')?.value;
    const row = getRows(rows, currencyValue);
    const calcParams = getDepositCalculatorParams(userInputParams, row, paramsViewSettings);
    const { rate, income, finalSum, type = '' } = calcParams;
    const handleDefaultParamsCals = () => {
        setDefaultParamsCalc({
            field,
            defParams: getDefaultParamsMax(row, isNewClient),
            calcParams,
            monthsValue: 'minMonths',
            map: MAP,
        });
    };
    useEffect(() => {
        if (!isDefaultParams(defaultParams) && row) {
            handleDefaultParamsCals();
        }
    }, [defaultParams, rows]);
    const isMaxRate = rate === getDefaultParamsMax(row, isNewClient)?.rate;
    return (_jsx(CalculatorLayout, { className: className, title: title, ...rest, children: _jsxs("section", { className: style(CalculatorStyle.wrapper, className), children: [_jsxs("div", { className: CalculatorStyle.input, children: [_jsxs("div", { className: "flex gap-m", children: [renderWantedSumInput({
                                    className: 'w-full',
                                    title: `Сумма, ${currencyValue?.text}`,
                                    min: calcParams.minSum,
                                    max: calcParams.maxSum,
                                    ...field('moneyValue'),
                                    value: calcParams.moneyValue,
                                    postfix: currencyValue?.text,
                                    step: getStep(currencyValue?.key),
                                }), rows && rows?.length > 1 ? (_jsx(SelectControl, { label: "\u0412\u0430\u043B\u044E\u0442\u0430", options: currencyOptions, ...field('currency') })) : null] }), renderMonthsInput({
                            title: 'Срок, месяцев',
                            min: calcParams.minMonths,
                            max: calcParams.maxMonths,
                            availableMonths: calcParams.availableMonths,
                            ...field('monthsValue'),
                            value: calcParams.monthsValue,
                        }), renderDepositParamsForm({ ...calcParams, ...paramsViewSettings }, field)] }), renderRate({
                    rate,
                    children: renderMaxRateButton(handleDefaultParamsCals, isMaxRate),
                }), renderDepositResult({
                    income,
                    finalSum,
                    buttons: [...buttons, getTariffButton(calcSource?.buttons, type)],
                    footnotes: [footnote],
                    postfix: currencyValue?.text,
                    isCapitalization: field('isMonthlyInterestPayment').value,
                })] }) }));
});
const getStep = (key = '') => (isRubles(key) ? 1000 : 100);
const getTariffButton = (buttons = [], btnType = '') => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { type, ...button } = buttons.find((_) => _.type === btnType) ?? {};
    return button;
};
const renderMaxRateButton = (handleDefaultParamsCals, isMaxRate = false) => isMaxRate ? null : (_jsx(Button, { type: "button", version: "secondary", onClick: handleDefaultParamsCals, children: "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u0443\u044E \u0441\u0442\u0430\u0432\u043A\u0443" }));
//# sourceMappingURL=CalculatorDeposit.js.map